module.exports = __webpack_public_path__ + "static/media/social_media.b8ea6d33.svg";